import { useState, type FormEvent } from 'react';
import { Link } from '@tanstack/react-router';
import { Wordmark } from './wordmark';

export function Footer() {
  return (
    <footer className="border-t border-border bg-bg-soft">
      <EmailCapture />

      <div className="border-t border-border">
        <div className="container-page grid gap-12 py-16 md:grid-cols-4">
          <div className="md:col-span-1">
            <Wordmark />
            <p className="mt-4 max-w-xs text-sm text-ink-2">Chain-of-custody for pharmacy delivery.</p>
            <p className="mt-3 text-xs text-ink-3">LYN Rx LLC · Ohio</p>
          </div>

          <FooterCol title="Product">
            <a href="/#features" className={footerLink}>
              Features
            </a>
            <a href="/#pricing" className={footerLink}>
              Pricing
            </a>
            <a href="/#faq" className={footerLink}>
              FAQ
            </a>
            <a href="https://app.lynrx.co/login" className={footerLink}>
              Sign in
            </a>
          </FooterCol>

          <FooterCol title="Company">
            <span className={footerPlaceholder} aria-disabled="true">
              About <span className="text-ink-3">— soon</span>
            </span>
            <Link to="/contact" className={footerLink}>
              Contact
            </Link>
            <span className={footerPlaceholder} aria-disabled="true">
              Updates <span className="text-ink-3">— soon</span>
            </span>
          </FooterCol>

          <FooterCol title="Legal">
            <Link to="/privacy" className={footerLink}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={footerLink}>
              Terms of Service
            </Link>
            <Link to="/baa" className={footerLink}>
              BAA
            </Link>
          </FooterCol>
        </div>

        <div className="border-t border-border">
          <div className="container-page flex flex-col items-start justify-between gap-2 py-6 text-xs text-ink-3 md:flex-row md:items-center">
            <span>© {new Date().getFullYear()} LYN Rx LLC. All rights reserved.</span>
            <span>Built with care in Ohio.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

const footerLink = 'block text-sm text-ink-2 transition-colors hover:text-ink';
const footerPlaceholder = 'block text-sm text-ink-2 cursor-default select-none';

function FooterCol({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h4 className="text-xs font-semibold uppercase tracking-wider text-ink">{title}</h4>
      <div className="mt-4 space-y-3">{children}</div>
    </div>
  );
}

function EmailCapture() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.includes('@')) return;
    setSubmitted(true);
  };

  return (
    <div className="container-page py-14">
      <div className="grid gap-6 md:grid-cols-2 md:items-end">
        <div>
          <h3 className="text-xl font-semibold tracking-tight text-ink md:text-2xl">
            Get LYN Rx updates.
          </h3>
          <p className="mt-2 text-sm text-ink-2">
            Monthly cadence. Build progress, customer stories, and what's shipping next. Easy unsubscribe.
          </p>
        </div>
        {submitted ? (
          <p className="text-sm text-primary md:text-right">Thanks — check your inbox to confirm.</p>
        ) : (
          <form onSubmit={onSubmit} className="flex w-full max-w-md gap-2 md:ml-auto">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@pharmacy.com"
              className="flex-1 rounded-lg border border-border bg-white px-3 py-2 text-sm text-ink shadow-sm outline-none transition-colors focus:border-primary focus:ring-1 focus:ring-primary"
            />
            <button
              type="submit"
              className="inline-flex items-center justify-center rounded-lg bg-ink px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-ink/90"
            >
              Subscribe
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
